$(function()
{
   var CartBox = (function()
   {
       var _t,_elem = function()
       {
           return $('#cart-alert');
       },_cartPoint = function()
       {
           return $('#cart-point');
       },
       show = function()
       {
           _elem().fadeIn('fast').animate(
            {
                'right': '5px'
            },
            {
                duration: 'slow', queue: false
            }, function()
            {
                // Animation complete.
            });
       },
       hide = function()
       {
           _elem().fadeOut('slow').animate(
            {
                'right': '-30%'
            },
            {
                duration: 'fast', queue: false
            }, function()
            {
            });
            _t && clearTimeout(_t);
       },
       timeTrigger = function(time, callBefore, callAfter)
       {
           callBefore.call(this);
           _t = setTimeout(function(){ callAfter.call(this), clearTimeout(_t)} , time);
       };
       
       
       $(document.body).append('<div id="cart-alert"><div class="content"></div></div>');
       //$(document).on("click", "#cart-alert", hide);
       
       this.alertError = function(msg)
       {
          this.content('<span class="error">' + msg + '</span>');
       }
       this.alertSuccess = function(msg)
       {
           this.content('<span class="success">' + msg + '</span>');
       }
       this.content = function(msg)
       {
           _elem().find('.content').html(msg);
           timeTrigger(3000, show, hide);
       }
       this.update = function()
       {
           $('#cart-point').css('visibility', 'visible');
           var cartTxt;
           if(StoreApp.cartSummary.items != 0)
           {
                cartTxt = '<a href="' + StoreApp.cartUrl + '" class="fill-cart"><span class="icon"><i class="fa fa-shopping-bag" aria-hidden="true"></i></span><span class="cart-item">' + StoreApp.cartSummary.items + '</span></a>';
           }
           else
           {
               cartTxt = '<a href="#"><span class="icon"><i class="fa fa-shopping-bag" aria-hidden="true"></i></span><span class="cart-item">0</span></a>';
           }
           
           _cartPoint().html(cartTxt);
       }
       this.update();
       
       return this;
   }).call(this);
   
    $(document).on("click", "a.to-cart", function(e)
    {
        var frmData = $(this).data(), $this = $(this);
        if(frmData.pid && frmData.stag)
        {
            _actionSpinner($this, true);
            $.getJSON(StoreApp.addCartUrl, frmData, function(data)
            {
                if(data.item && data.item.code && data.item.name && data.item.price && data.total && data.items)
                {
                    _actionSpinner($this, false);
                    StoreApp.cartSummary.items = data.items;
                    StoreApp.cartSummary.amount = data.total;
                    StoreApp.cartSummary._amount = data._total;
                    CartBox.content('<div class="product"><div class="img"><img src="' + data.item.image + '"></div><div class="details"><span class="name">Your <b>' + data.item.name + '</b> was added into cart.</span><span class="price">' + data.item.price + '</span><a href="' + StoreApp.cartUrl  + '" class="btn btn-orange btn-sm"><i class="fa fa-shopping-basket" aria-hidden="true"></i> View Cart</a></div></div>');
                    CartBox.update();
                }
            });
        }
        else
        {
            CartBox.alertError("Item did not add into shopping cart, Refresh your browser.");
        }

        e.preventDefault(); 
    }).on("click", "a.to-buy", function(e)
    {
        var btnId = $(this).data('trigger');
        if(btnId)
        {
            var frmData = $("#" + btnId).data(),
                $this = $(this);
            if(frmData.pid && frmData.stag)
            {
                _actionSpinner($this, true);
                $.getJSON(StoreApp.addCartUrl, frmData, function(data)
                {
                    if(data.item && data.item.code && data.item.name && data.item.price && data.total && data.items)
                    {
                        _actionSpinner($this, false);
                        window.location = StoreApp.cartUrl;
                    }
                });
            }
        }
        e.preventDefault();
    });
    function _actionSpinner($elem, status)
    {
        if(status)
        {
            if($elem.find(".fa")[0]) $elem.find(".fa").addClass('fa-spinner fa-spin');
            else $elem.prepend('<span class="fa fa-spinner fa-spin fa-fw xhr-spin"></span>');
        }
        else
        {
            if($elem.find('.xhr-spin')[0]) $elem.find('.xhr-spin').remove();
            else $elem.find(".fa").removeClass('fa-spinner fa-spin');
        }
    }
    $(".product a.set-color").on("click", function(e)
    {
        var data = $(this).data();
        if(data.to && data.id && data.img)
        {
            $(this).parent().parent().find('.color').removeClass('selected');
            $("#featured-image").attr("data-src", data.img).find('img').attr("src", data.img);
            $(this).parent().addClass('selected');
            $("#" + data.to).data('attr', data.id);
        }
        e.preventDefault();
    });
    
    $('.input-spin').each(function()
    {
        $(this).removeClass('input-spin').removeClass('input');
        $(this).before('<div class="in-n-spinner"><a class="in-minus" href="#">-</a>' + $(this).parent().html() + '<a href="#" class="in-plus">+</a></div>');
        $(this).prev('.in-n-spinner').find('input').attr('type', 'text');
        $(this).remove();
    });
    $(document).on("click", ".in-n-spinner .in-minus", function(e)
    {
        var $in = $(this).next('input'),
            n = $in.val(),
            min = parseInt($in.attr('min'));
        if(n)
        {
            n = parseInt(n);
            n--;
        }
        else  n = 0;
        $in.trigger( "change" );
        if(min && min > n) n = min;
        $in.val(n);
        
        updateCartQty(n, $(this).next('input.qty-control'));
        
        e.preventDefault();
    }).on("click", ".in-n-spinner .in-plus", function(e)
    {
        var $in = $(this).prev('input'),
            n = $in.val(),
            max = parseInt($in.attr('max'));
        if(n)
        {
            n = parseInt(n);
            n++;
        }
        else  n = 0;
        
        if(max && max < n) n = max;
        $in.trigger( "change" );
        $in.val(n);
        
        updateCartQty(n, $(this).prev('input.qty-control'));
        
        e.preventDefault();
    });
    var updateCartQty = function(qty, $input)
    {
        var formData = {};
        formData[$input.attr('name')] = qty;
        waitBox.show();
        $.post(StoreApp.baseUrl + "update-cart", formData, function(result)
        {
            if(result['t'] && result['rows'])
            {
                $('.cart .subttotal').html(result['t']);
                $('#cart-point .cart-total').html(result['t']);
                var rows = result['rows'];
                for(var x in rows)
                {
                    $('.cart .itid-' + x).html(rows[x]);
                }
            }
            waitBox.hide();
        });
    }
    $("#main .category-area li a").hover(function()
    {
        var cls = $(this).find('i').attr('class').toString().match(/(ic\-x16\-[a-zA-Z0-9\-]+)/g) ? RegExp.$1 : 'ic-x16';
        
        $(this).find('i').addClass(cls + '-o');
    }, function()
    {
        var cls = $(this).find('i').attr('class').toString().match(/(ic\-x16\-[a-zA-Z0-9\-]+\-o)/g) ? RegExp.$1 : 'ic-x16-o';
        
        $(this).find('i').removeClass(cls);
    });
    waitBox.init();
    
    if(StoreApp.delivery_addr && $('#delivery-info .delivery-basic').length)
    {
        var delivertAddr = StoreApp.delivery_addr;
        
        $('#d-rname').val(delivertAddr.rname);
        $('#d-rphone').val(delivertAddr.rphone);
        $('#d-address').val(delivertAddr.address);
        
        if(delivertAddr.location_type) $('#d-loctype').val(delivertAddr.location_type);
        else if(delivertAddr.location_type_id > 0) $('#d-loctype').val(delivertAddr.location_type_id);
        
        //console.log("Lets", delivertAddr.location_type, delivertAddr.location_type_id);
        
        $('#district_id').val(delivertAddr.district_id);
        
        if(delivertAddr.city) $('#city').val(delivertAddr.city);
        else if(delivertAddr.city_id) $('#city').val(delivertAddr.city_id);
        
        if(delivertAddr.address_optional) $('#d-address_optional').val(delivertAddr.address_optional);
        if(delivertAddr.postal_code) $('#postal_code').val(delivertAddr.postal_code);
        
        if(delivertAddr.recipient_email) $('#d-recipient_email').val(delivertAddr.recipient_email);
    }
    
    //Menu
    
    var $menuItem = $("#main-menu .secondary");
    var $menuAction = $("header .menu-action");
    var isHideMenu = !$menuItem.is(":hidden");
    
    $('.user-menu-item').each(function()
    {
        $menuAction.append($(this).html());
    });
    $(document.body).append('<div class="menu-screen"><div class="menu-header"><div class="logo">' + $('#logo-link').html() + '</div></div><div class="menu-body">' + $menuItem.html() + '</div></div>');
    $menuAction.append('<a id="nav-menu" href="#"><span class="icon"></span></a>');
    
    
    $('.menu-screen .menu-header').append('<a class="menu-close" href="#"></a>');
    
    function menuScreen(show)
    {
        if(show)
        {
            $('html,body').css('overflow', 'hidden');
            $('.menu-screen').fadeIn(600);
        }
        else
        {
            $('html,body').css('overflow', 'auto');
            $('.menu-screen').fadeOut(600);
        }
    }
    $("#nav-menu").on("click", function(e)
    {
        menuScreen(true);
        e.preventDefault();
    });
    $(document).on('click', '.menu-screen .menu-close', function(e)
    {
        menuScreen(false);
        e.preventDefault();
    });
    
    $(document).on('click', 'a.accordion', function(e)
    {
        var $nxt = $(this).next();
        
        if ($nxt[0].style.maxHeight) {
            // accordion is currently open, so close it
            $nxt[0].style.maxHeight = null;
            $(this).removeClass('is-open');
            $nxt.removeClass('expand');
          } else {
            // accordion is currently closed, so open it
            $nxt[0].style.maxHeight = $nxt[0].scrollHeight + "px";
            $(this).addClass('is-open');
            $nxt.addClass('expand');
          }
        
        
        e.preventDefault();
    });
    
});


var waitBox = {
    elemID: 'wait-box',
    init: function()
    {
        var $box = $('<div />', { 'id' : this.elemID});

        $box.html($('<div />', {'class' : 'b-text'}).html('<i class="fa fa-cog fa-spin"></i> Please wait...'));

        $(document.body).append($box);
        $(window).on("resize", this.resize);
        this.resize();
    },
    resize: function()
    {
        var css = {};
        css.height = $(window).height();
        css.width = $(window).width();
        
        $('#' + this.elemID).css(css);
    },
    show : function()
    {
        $('#' + this.elemID).fadeIn(400);
    },
    hide : function()
    {
        $('#' + this.elemID).fadeOut(400);
    }
}

function toCart()
{
    alert("added");
}